export default __webpack_public_path__ + "static/media/floor-recessed.c83d8717.svg";